import React from 'react';

import { renderUserInputDate } from "./DropdownFunctions";

import PropTypes from "prop-types";

const UserInputDate= (props ) =>
{
	return (
		<div key={props.keyValue} className={props.containerClassName}>
			{ renderUserInputDate(props) }
		</div>
	);
}

export default UserInputDate;

UserInputDate.defaultProps =
	{
		defaultClassName: 'form-group'
	}

UserInputDate.propTypes = {
	onChange: PropTypes.func.isRequired
};